import React from 'react';
import './ActivitySingle.css';

import { Button, Lightbox, PageTitle, SidebarHeading } from '../../../components';
import { activities } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaChartLine, FaGlobe } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';



const ActivitySingle = () => {

  const location = useLocation();
  const activity = location.state;

  const highlights = activity.highlights; // Activity Highlights
  const requirements = activity.requirements; // Activity Requirements

  const encodedQuery = encodeURIComponent(activity.title);

  return (
    <>
      {/* Page Title */}
      <PageTitle title={activity.title} page={"Activity Single"} />

      <section className='activity-single page-single'>

        <div className='sidebar activity-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all Activity'} />

            <div className='box-container'>
              {activities.map(activity => {
                return  (
                /* Link to the individual activity page */
                <Link
                  to={{
                    pathname: '/Activities/' + activity.title,
                  }}
                  location = {{activity}}
                  state= {activity}
                  key={activity.id}
                  className='item'><span><div className='icon'>{renderIcon(activity.title)}</div>{activity.title}</span> {/* Activity Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

        <div className='activity-info page-info'>

          {/* Activity Image */}
          <div className='image'>
            <img src={activity.image} alt={activity.title} />
          </div>

          <div className='content'>

            <div className='intro'>
              <h3 className='main-heading'>{activity.title} Activity</h3> {/* Activity heading */}
              <Button link={`Tours?activity=${encodedQuery}`} title='Related Tours' />
            </div>

            {/* Activity Content */}
            {activity.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Actiivty Image gallery */}
          <Lightbox images={activity.gallery} />

          {/* Activity Highlights */}
          <div className='activity-highlights sub-section'>

            <h3 className='sub-heading'>What to Expect:</h3>

            <p>Here’s what you can look forward to during our {activity.title} activity:</p>

            {/* List of Activity Highlights */}
            <ul>
              {highlights.map((item, index) => {
                return <li key={index}><FaGlobe className='icon' />{item}</li>
              })}
            </ul>

          </div>

          {/* Activity Requirements */}
          <div className='activity-requirements sub-section'>

            <h3 className='sub-heading'>Skill Level and Requirements:</h3>

            <p>Before joining our {activity.title} Activity, please note the following requirements:</p>

            {/* List of Activity Requirements */}
            <ul>
              {requirements.map((item, index) => {
                return <li key={index}><FaChartLine className='icon' />{item}</li>
              })}
            </ul>

          </div>

        </div>

      </section>
    </> 
  );
}

export default ActivitySingle;